var $ = require('jquery');

module.exports = {
	init: function () {
		$(function () {
			// Select all anchor links that point to an ID on the same page
			$('a[href*="#"]:not([href="#"],[href*="fancybox-lightbox"])').on(
				'click',
				function (event) {
					// Ensure the link is for an internal anchor
					if (
						location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
						location.hostname == this.hostname
					) {
						var target = $(this.hash); // Get the target element using the hash
						target = target.length ? target : $('[name=' + this.hash.slice(1) + ']'); // Fallback for name attribute
						if (target.length) {
							// #blog anchors down to a FacetWP-powered section. The browser's
							// native hash navigation adds a new history entry, which fires a
							// `popstate` event; FacetWP's own back/forward-cache detection
							// misreads that as a real bfcache restore and marks itself "not
							// loaded" again, so the very next facet selection gets wiped out
							// before it's sent. Handle #blog ourselves via replaceState, which
							// updates the address bar without creating a history entry, so no
							// popstate fires.
							if ('#blog' === this.hash) {
								event.preventDefault();
								if (history.replaceState) {
									history.replaceState(
										null,
										'',
										location.pathname + location.search + this.hash
									);
								}
							}

							var offset = 150; // Define your desired offset (e.g., height of a sticky header)
							$('html, body').animate(
								{
									scrollTop: target.offset().top - offset, // Calculate scroll position with offset
								},
								250
							); // Set the duration of the smooth scroll in milliseconds

							// A browser only moves focus to an anchor target if that target is
							// focusable. Section elements aren't, so focus stays behind on the
							// link and keyboard/screen reader users carry on from the nav rather
							// than from the section they jumped to. preventScroll keeps this from
							// fighting the animation above.
							var targetEl = target[0];

							if (!targetEl.hasAttribute('tabindex')) {
								targetEl.setAttribute('tabindex', '-1');
							}

							targetEl.focus({ preventScroll: true });
						}
					}
				}
			);
			$(window).on('load', function () {
				// If there's a hash in the URL on page load, scroll to it with offset
				if (window.location.hash) {
					var target = $(window.location.hash);
					target = target.length
						? target
						: $('[name=' + window.location.hash.slice(1) + ']');
					if (target.length) {
						var offset = 150; // Define your desired offset
						$('html, body').animate(
							{
								scrollTop: target.offset().top - offset,
							},
							250
						);
					}
				}
			});
		});
	},
};
